export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '13f09bd5-ab96-48bb-9972-3322be25e9c0',
      authority: 'https://clearscrapb2cdev.b2clogin.com/clearscrapb2cdev.onmicrosoft.com/B2C_1A_DEV_SIGNINPARTNER',
      authorityDomain:'clearscrapb2cdev.b2clogin.com'
    },
  },
  apiConfig: {
    scopes: ['https://clearscrapb2cdev.onmicrosoft.com/6a41f527-f170-4642-8f78-25d8a2e19c14/cs.api.access'],
    uri: 'https://clearscrapappsindev01-dnbqahazfpbcgrcf.southindia-01.azurewebsites.net',
  },
  googleMapsApiKey: 'AIzaSyB5DT4BmjlntgtFmIDN7NjsgE_Wr7IEitQ',
};


